export const BRAND_COLORS = {
    ember: '#FF5236',
    red: '#FF2345',
    rose: '#E8185F',
    ink: '#07080C',
    night: '#0D1017',
    navy: '#0A1020'
} as const

export const BRAND_GRADIENT = [
    { offset: 0, color: BRAND_COLORS.ember },
    { offset: 0.55, color: BRAND_COLORS.red },
    { offset: 1, color: BRAND_COLORS.rose }
] as const

/*
 * Every glyph is drawn upright on a 150 unit cap height (x-height 106,
 * stems 30, horizontals 26) and leaned 12 degrees with skewX(-12).
 * The translate puts the leaned baseline back at x = 0 (150 * tan 12deg).
 */
export const WORDMARK = {
    width: 336.6,
    height: 150,
    span: 314,
    viewBox: '0 0 336.6 150',
    transform: 'translate(31.88 0) skewX(-12)',
    path: [
        'M76 0H106V150H0V108A64 64 0 0 1 64 44H76Z',
        'M30 124V106A36 36 0 0 1 66 70H76V124Z',
        'M122 44H152V150H122Z',
        'M139 0H211A60 60 0 0 1 271 60C271 104 257 132 235 150Z',
        'M188.88 26H209A32 32 0 0 1 241 58C241 74 239.5 88 235 98Z',
        'M284 44H314V150H284Z'
    ].join(' ')
} as const

/*
 * The D/V shield from the wordmark on its own, optically centred
 * in a 256 unit app icon tile.
 */
export const MONOGRAM = {
    size: 256,
    span: 132,
    viewBox: '0 0 256 256',
    transform: 'translate(65.4 58) skewX(-12)',
    path: [
        'M0 0H72A60 60 0 0 1 132 60C132 104 118 132 96 150Z',
        'M49.88 26H70A32 32 0 0 1 102 58C102 74 100.5 88 96 98Z'
    ].join(' ')
} as const

export const BRAND_GRADIENT_CSS = `linear-gradient(90deg, ${BRAND_GRADIENT.map(stop => `${stop.color} ${Math.round(stop.offset * 100)}%`).join(', ')})`
